import { z } from "zod";
import { MediaProvider } from './enums';

export const Media = z.object({
  provider: MediaProvider,
  id: z.string(),
  type: z.string().nullable(),
  name: z.string(),
  link: z.string(),
  workspaceId: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  author: z.string().nullish(),
  authorProfile: z.string().nullish(),
  thumbnail: z.string().nullish(),
  downloadLink: z.string().nullish(),
})
export type Media = z.infer<typeof Media>;

export const MediaProviderType = MediaProvider;
export type MediaProviderType = z.infer<typeof MediaProviderType>;